import { useState, useEffect } from 'react';
import { Trans, useTranslation } from "react-i18next";

import { Link } from 'react-router';
import { useLocation } from 'react-router'

import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import { Button, Container } from '@mui/material';
import IconButton from '@mui/material/IconButton';

import Typescript from '@mui/material/Typography'

import Title from '../../components/Title'
import Text from '../../components/Text'

import icon_1 from '../../images/image.png'

import image from '../../images/symptoms/confronto.png'


export default function Article() {

  const { t, i18n } = useTranslation();
  let location = useLocation()

  const [hash, setHash] = useState()
  const [item, setItem] = useState({})

  useEffect(() => {
    //console.log(location);
    setHash(location.hash.replace('#', ''))
  }, [])

  useEffect(() => {
    if (hash !== undefined) {
      if (i18n.language === "de")
        fetch("news/" + hash + "/data_de.json")
          .then((response) => response.json())
          .then((data) => { setItem(data) })
      else
        fetch("news/" + hash + "/data_it.json")
          .then((response) => response.json())
          .then((data) => { setItem(data) })
    }
  }, [hash, i18n])


  return (
    <Container className="bgwhite p-4">
      <Box className="article">

        <Title variant="card" size="22pt" text={item.title} color="orange" />

        <Text variant="bolditalic" text={item.intro} color="green" />

        {item.paragraphs !== undefined && item.paragraphs.map((p, index) => {
          return (
            <div key={index} className="py-2">
              <Text variant="normal" text={p} color="black" />
            </div>
          )
        })}

        {/* Pictures */}
        <Grid container justifyContent="space-around" alignItems="flex-start" spacing={2}>
          {item.images !== undefined && item.images.map((it, index) => {
            return (
              <>
                <Grid key={index} size={{ xs: 12, sm: 12, md: 5 }} className="center">
                  <img src={"news/" + item.id + "/" + it.url} className="orangeborder center" />
                  <Text variant="imagedescription" text={it.alt} color="green" />
                </Grid>
              </>
            )
          })}

        </Grid>

        <div className="right">
          <Link underline="none" to={"/news"}>
            <Button>{t("return")}</Button>
          </Link>
        </div>

      </Box>
    </Container>

  );
}
